/**
 * Procurement Pipeline — dedicated page for partner procurement tracking.
 * Mirrors fleet-admin's VehiclesProcurementPage pattern.
 */

import PartnerVehicleRecords from '@/components/vehicles/PartnerVehicleRecords';
import SectionDrawer from '@/components/navigation/SectionDrawer';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function VehicleProcurement() {
    const { signOut } = useAuth();
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await signOut();
        navigate('/auth');
    };

    const handleNavChange = (section: string) => {
        navigate(`/${section}`);
    };

    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            {/* Mobile nav */}
            <div className="lg:hidden">
                <SectionDrawer
                    activeSection="fleet/procurement"
                    onSectionChange={handleNavChange}
                    onSignOut={handleSignOut}
                />
            </div>

            <div>
                <h1 className="text-3xl font-semibold tracking-tight mb-2">Procurement</h1>
                <p className="text-muted-foreground">Track your vehicles through the procurement pipeline.</p>
            </div>
            <PartnerVehicleRecords group="procurement" />
        </div>
    );
}
